import { MantineThemeOverride } from "@mantine/core";
import { FloatingPosition } from "@mantine/core/lib/Floating";

declare module "@mantine/core" {
  export interface MantineThemeOther {
    arc: {
      colors: string[];
      paddings: string[];
      margins: string[];
      shadows: { [key: string]: string };
    };
    table: {
      height: string;
      header: {
        backgroundColor: string;
      };
      row: {
        height: string;
      };
    };
    formula: {
      title: {
        height: string;
      };
      expressionTable: {
        height: string;
      };
    };
    imageHeight: {
      xxs: string;
      xs: string;
      sm: string;
      md: string;
      lg: string;
    };
    card: {
      width: number;
      height: number;
      fontWeight: number;
    };
    loginButton: {
      height: string;
    };
    siderBarWidth: number;
    popOver: {
      position: FloatingPosition;
      spacing: { [key: string]: number };
    };
    numberInput: {
      precision: number;
      step: number;
    };
  }
}
// [navy Blue , Orange , sky blue]
const colors = ["#001250", "#fc7700", "#228be6", "#eeeeee", "#faad14", "#ced4da", "#0a0a0a1a", "#0a0a0a4d"];
const theme: MantineThemeOverride = {
  colorScheme: "light",
  radius: {
    sm: "0px",
  },
  fontSizes: {
    sm: "12px",
    md: "16px",
    lg: "20px",
    xl: "24px",
  },
  fontFamily: "Rubik",
  defaultRadius: 0,
  other: {
    arc: {
      colors: colors,
      paddings: ["0px", "5px", "10px", "15px", "20px"],
      margins: ["0px", "5px", "10px", "15px", "20px"],
      shadows: {
        xs: "0 2px 2px 0 rgba(0,0,0,0.14), 0 3px 1px -2px rgba(0,0,0,0.12), 0 1px 5px 0 rgba(0,0,0,0.2)",
        sm: "1px 1px 8px 1px #969696",
        md: `1px 2px 5px ${colors[0]}`,
        lg: "4px 3px 8px 1px #969696",
        xl: `1px 2px 5px ${colors[1]}`,
      },
    },
    siderBarWidth: 300,
    card: {
      width: 450,
      height: 250,
      fontWeight: 500,
    },
    loginButton: {
      height: "32px",
    },
    table: {
      height: "calc(100vh - 310px)",
      header: {
        backgroundColor: "#f6f6f6",
      },
      row: {
        height: "24px",
      },
    },
    formula: {
      title: {
        height: "40px",
      },
      expressionTable: {
        height: "calc(100vh - 520px)",
      },
    },
    imageHeight: {
      xxs: "14px",
      xs: "20px",
      sm: "30px",
      md: "40px",
      lg: "50px",
    },
    popOver: {
      position: "top",
      spacing: {
        xs: 4,
        sm: 6,
        md: 8,
        lg: 10,
        xl: 20,
      },
    },
    numberInput: {
      precision: 2,
      step: 1,
    },
  },
  colors: {
    baground: ["fdf"],
    dangerColor: ["red"],
  },
  headings: {
    sizes: {
      h1: { fontSize: "30px" },
    },
  },
};
export default theme;
